<template>
<b-container>
  <div>
    <!-- <b-card-group deck>
      <b-card v-for="item in products.productData" :key="item.productId" :img-src="item.productImage" img-top>
        <b-card-text>
          <a :href="item.productUrl" target="_blank">{{ item.productName }}</a>
        </b-card-text>
        <b-list-group flush>
          <b-list-group-item>Cras justo odio</b-list-group-item>
          <b-list-group-item>Dapibus ac facilisis in</b-list-group-item>
          <b-list-group-item>Vestibulum at eros</b-list-group-item>
        </b-list-group>
      </b-card>
    </b-card-group> -->

    <b-card-group deck>
      <b-card v-for="item in goldbox.productData" :key="item.productId" :img-src="item.productImage" img-top title="쿠팡 골드박스">
        <b-card-body>
          <b-card-text>
            <a :href="item.productUrl" target="_blank">{{ item.productName }}</a>
          </b-card-text>
        </b-card-body>
          <b-list-group-item>{{ item.productPrice.toLocaleString() }} 원</b-list-group-item>
          <b-list-group-item v-if="item.isFreeShipping">무료 배송</b-list-group-item>
          <b-list-group-item v-if="item.isRocket">로켓배송</b-list-group-item>
      </b-card>
    </b-card-group>
  </div>
</b-container>
  
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'

Vue.use(BootstrapVue)
const API = 'https://api.bidit.kr/api/v2/coupang/products'

export default {
  props: {
    keyword: {
      type: String,
      default: 'foods'
    }
  },
  data () {
    return {
      products: [],
      goldbox: null
    }
  },
  methods: {
    getProducts: async (keyword) => {
        console.log(keyword)
        const response = await axios.get(`${API}/${keyword}`)
        return response
    },
    getGoldbox: async () => {
      const response = await axios.get(`${API}/goldbox`)
      return response
    }
  },
  async mounted () {
    // const response = await this.getProducts(this.keyword)
    // this.products = response.data.data
    const response = await this.getGoldbox()
    this.goldbox = response.data.data
  }
}
</script>

<style scoped src="bootstrap/dist/css/bootstrap.css"></style>
<style scoped src="bootstrap-vue/dist/bootstrap-vue.css"></style>